import React from "react";

export default (props) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9ZM12.6273 6.2727C12.8909 6.53631 12.8909 6.96369 12.6273 7.2273L8.1273 11.7273C7.86369 11.9909 7.43631 11.9909 7.1727 11.7273L5.3727 9.9273C5.1091 9.66369 5.1091 9.23631 5.3727 8.9727C5.63631 8.7091 6.06369 8.7091 6.3273 8.9727L7.65 10.2954L9.66135 8.28405L11.6727 6.2727C11.9363 6.0091 12.3637 6.0091 12.6273 6.2727Z"
      />
    </svg>
  );
};
